// booking-types.ts

// Define the booking steps enum
export enum BookingStep {
  LOCATION_STEP,
  CATEGORIES_STEP,
  SERVICE_SELECTION,
  PROVIDER_STEP,
  DATE_TIME_SELECTION,
  CUSTOMER_INFO,
  CONFIRMATION,
  BOOKING_CONFIRMED,
}

// Type for widget configuration
export interface WidgetConfiguration {
  isLocationsActivated: boolean;
  isProvidersActivated: boolean;
  isCategoriesActivated: boolean;
  [key: string]: any;
}

// Step definition interface
export interface StepDefinition {
  name: string;
  step: BookingStep;
  icon: JSX.Element;
  nodeData?: any; // Add the node data from the flow configuration
}
